<mat-card>
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
      <div class="left">
        <mat-card-title>{{ pageTitle }}</mat-card-title>
        <mat-card-subtitle>{{ pageSubtitle }}</mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex">
        <button mat-flat-button (click)="navigateToCreate()">
          <mat-icon>add</mat-icon>
          Add SuperAdmin
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <mat-divider></mat-divider>

    <mat-tab-group (selectedIndexChange)="onTabChange($event)" class="my-15">

      <!-- ACTIVE TAB -->
      <mat-tab label="Active">
        <ng-template matTabContent>
          <div class="tab-content">
            @if(isLoading) {
            <div class="g-just-flex flex-column align-items-center py-40">
              <mat-spinner diameter="40"></mat-spinner>
              <p class="mt-16">Loading users...</p>
            </div>
            } @else if(tableDataSource.data.length > 0) {
            <table mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element"><strong>{{ element.fullName }}</strong></td>
              </ng-container>

              <ng-container matColumnDef="accountType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let element">
                  <mat-chip [ngClass]="element.accountType === 'SuperAdmin' ? 'chip-superadmin' : 'chip-eventmanager'">
                    {{ element.accountType === 'SuperAdmin' ? 'Super Admin' : 'Event Manager' }}
                  </mat-chip>
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
              </ng-container>

              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let element">{{ element.phoneNumber || 'N/A' }}</td>
              </ng-container>

              <ng-container matColumnDef="lastLogin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.lastLoginAt) {
                  <span>{{ element.lastLoginAt | date: 'medium' }}</span>
                  } @else {
                  <span class="subtitle-text-color-2">Never</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'mediumDate' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span class="status-badge" [ngClass]="element.status === 'Active' ? 'active' : 'inactive'">
                    {{ element.status }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  <button mat-icon-button [matMenuTriggerFor]="activeMenu" matTooltip="Actions">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #activeMenu="matMenu">
                    <button mat-menu-item (click)="viewDetails(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="resetPassword(element)">
                      <mat-icon>lock_reset</mat-icon>
                      <span>Reset Password</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="deactivateUser(element)">
                      <mat-icon>block</mat-icon>
                      <span>Deactivate</span>
                    </button>
                    <button mat-menu-item (click)="deleteUser(element)" class="delete-action">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
            </table>
            } @else {
            <app-empty-state icon="PEOPLE" title="No active SuperAdmin users found" subtitle="Create your first SuperAdmin user to get started"></app-empty-state>
            }
          </div>
        </ng-template>
      </mat-tab>

      <!-- DEACTIVATED TAB (now also serves Deleted, via the toggle) -->
      <mat-tab label="Deactivated">
        <ng-template matTabContent>
          <div class="tab-content">

            <div class="g-just-flex flex-between align-items-center mb-12">
              <span class="subtitle-text-color-2">
                {{ showDeleted ? 'Showing deleted admins' : 'Showing deactivated admins' }}
              </span>
              <mat-slide-toggle [checked]="showDeleted" (change)="onShowDeletedToggle($event.checked)">
                Show Deleted
              </mat-slide-toggle>
            </div>

            @if(isLoading) {
            <div class="g-just-flex flex-column align-items-center py-40">
              <mat-spinner diameter="40"></mat-spinner>
              <p class="mt-16">Loading users...</p>
            </div>
            } @else if(tableDataSource.data.length > 0) {
            <table mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element"><strong>{{ element.fullName }}</strong></td>
              </ng-container>

              <ng-container matColumnDef="accountType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let element">
                  <mat-chip [ngClass]="element.accountType === 'SuperAdmin' ? 'chip-superadmin' : 'chip-eventmanager'">
                    {{ element.accountType === 'SuperAdmin' ? 'Super Admin' : 'Event Manager' }}
                  </mat-chip>
                </td>
              </ng-container>

              <!-- Deleted rows show the original (pre-scrub) email -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.isDeleted ? element.originalEmail : element.email }}</td>
              </ng-container>

              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let element">{{ element.phoneNumber || 'N/A' }}</td>
              </ng-container>

              <ng-container matColumnDef="lastLogin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.lastLoginAt) {
                  <span>{{ element.lastLoginAt | date: 'medium' }}</span>
                  } @else {
                  <span class="subtitle-text-color-2">Never</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'mediumDate' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span class="status-badge inactive">{{ element.isDeleted ? 'Deleted' : element.status }}</span>
                </td>
              </ng-container>

              <!-- Actions differ per-row based on element.isDeleted, not just the toggle -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  <button mat-icon-button [matMenuTriggerFor]="element.isDeleted ? deletedMenu : deactivatedMenu" matTooltip="Actions">
                    <mat-icon>more_vert</mat-icon>
                  </button>

                  <mat-menu #deactivatedMenu="matMenu">
                    <button mat-menu-item (click)="viewDetails(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="reactivateUser(element)">
                      <mat-icon>check_circle</mat-icon>
                      <span>Reactivate</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="deleteUser(element)" class="delete-action">
                      <mat-icon>delete</mat-icon>
                      <span>Delete Permanently</span>
                    </button>
                  </mat-menu>

                  <mat-menu #deletedMenu="matMenu">
                    <button mat-menu-item (click)="viewDetails(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="reactivateUser(element)">
                      <mat-icon>restore</mat-icon>
                      <span>Restore</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
            </table>
            } @else {
            <app-empty-state
              icon="PEOPLE"
              [title]="showDeleted ? 'No deleted system administrators' : 'No deactivated system administrators'"
              [subtitle]="showDeleted ? 'Deleted users will appear here' : 'All administrators are currently active'">
            </app-empty-state>
            }
          </div>
        </ng-template>
      </mat-tab>

    </mat-tab-group>
  </mat-card-content>
</mat-card>